import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-solutions-details-page',
  templateUrl: './solutions-details-page.component.html',
  styleUrls: ['./solutions-details-page.component.scss']
})
export class SolutionsDetailsPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
